import { useDispatch, useSelector } from "react-redux";
import {
  updateTitle,
  updateJobDesignation,
} from "../../../../../store/steps/stepOneSlice";
import { RootState } from "../../../../../store";
import { GenericInput } from "@asez/component-library";
import { STATIC_STRINGS } from "@asez/shared";
import { SIZES } from "@asez/shared";

const BasicInfo = () => {
  const dispatch = useDispatch();
  const title = useSelector((state: RootState) => state.stepOne.title);
  const jobDesignation = useSelector(
    (state: RootState) => state.stepOne.jobDesignation
  );

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(updateTitle(e.target.value));
  };

  const handleJobDesigChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    dispatch(updateJobDesignation(e.target.value));
  };

  return (
    <div className="w-2/5 mx-auto flex flex-col justify-start">
      <div className="flex flex-col py-2">
        <div className="font-medium pb-2">
          {STATIC_STRINGS.TITLE_FOR_ASSESSMENT}
        </div>
        <GenericInput
          type="text"
          onChange={handleTitleChange}
          placeholder={STATIC_STRINGS.ASSESSMENT_TITLE_PLACEHOLDER}
          value={title}
          size={SIZES.md}
        />
      </div>
      <div className="flex flex-col py-2">
        <div className="font-medium pb-2">{STATIC_STRINGS.JOB_DESIGNATION}</div>
        <GenericInput
          type="text"
          onChange={handleJobDesigChange}
          placeholder={STATIC_STRINGS.JOB_ROLE}
          value={jobDesignation}
          size={SIZES.md}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
